var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeStepIndex > 0)?_c('div',{staticClass:"wizzard"},[[_c('div',{class:{
                active: _vm.activeStepIndex === 1,
                passed: _vm.isEditPage || _vm.activeStepIndex > 1,
            }},[_vm._v(" Choose Files ")]),_c('div',{class:{
                active: _vm.activeStepIndex === 2,
                passed: _vm.isEditPage || _vm.activeStepIndex > 2,
            }},[_vm._v(" Basic creation info ")]),_c('div',{class:{
                active: _vm.activeStepIndex === 3,
                passed: _vm.isEditPage || _vm.activeStepIndex > 3,
            }},[_vm._v(" Screenshots / videos ")]),_c('div',{class:{
                active: _vm.activeStepIndex === 4,
                passed: _vm.isEditPage || _vm.activeStepIndex > 4,
            }},[_vm._v(" Finish ")])]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }